import LoanCalculatorContainer from '@apps/containers/LoanCalculatorContainer';
import createBasePath from '@stack/helpers/lib/createBasePath';
import Breadcrumb from '@stack/ui/components/Breadcrumb';
import { BreadCrumbOptions } from '@stack/ui/components/Breadcrumb/props';
import { NextPage } from 'next';

/**
 * ===========================
 * MAIN
 * ===========================
 */
const Page: NextPage = (props) => {
  const { webView, settings } = props;
  const { basePath } = createBasePath({ webView, type: 'cars' });

  // ============ VARIABLES
  const breadcrumbOpt: BreadCrumbOptions[] = [
    {
      title: 'AutoFacts',
      url: `${basePath}`,
    },
    {
      title: 'Loan Calculator',
      url: '',
    },
  ];
  const installmentRate = Number(settings.installment_rate);
  const depositRate = Number(settings.car_deposit_rate);
  const loanTenure = Number(settings.car_loan_tenure);

  // ============ VIEWS
  return (
    <>
      {!webView && <Breadcrumb options={breadcrumbOpt} bold />}
      <div>
        <LoanCalculatorContainer
          rate={installmentRate}
          depositRate={depositRate}
          loanTenure={loanTenure}
        />
      </div>
    </>
  );
};

/**
 * ===========================
 * EXPORT
 * ===========================
 */
export default Page;
